/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import CheckBox from '@/components/AZCustomComponent/FormGroup/CheckBox';
import styles from './styles.module.scss';
import { Divider } from '@/components/Divider';
import { useEffect, useRef } from 'react';

type Props = {
  label: string;
  value: number;
  checked: boolean;
  index: number;
  handleFilter: (value: number) => void;
};

export const Rating = ({ label, value, checked, index, handleFilter }: Props) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (index === 0 && checkboxRef.current) {
      checkboxRef.current.focus({ preventScroll: true });
    }
  }, [index]);

  return (
    <li className={styles.ratingItem}>
      <CheckBox
        inputRef={checkboxRef}
        variant="natural"
        onChange={() => {
          handleFilter(value);
        }}
        label={label}
        id={value.toString()}
        checked={checked}
      />
      <Divider className={styles.ratingDivider} />
    </li>
  );
};
